import { computed } from "vue";
import store from "@/store";

export default function() {
  const dialogEventId = computed(() => {
    // @ts-ignore
    return store.state.collaboration.dialogEventId;
  });

  const setDialogEventId = (value: boolean) => {
    store.commit("collaboration/setDialogEventId", value);
  };

  const setSelectedFolder = folder => {
    store.commit("collaboration/setSelectedFolder", folder);
  };

  const clearSelection = () => {
    store.commit("collaboration/clearSelection");
  };

  return {
    dialogEventId,
    setDialogEventId,
    setSelectedFolder,
    clearSelection
  };
}
